import _extends from "@babel/runtime/helpers/extends";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersTitle } from '../title/title';
import { StyledTemplate } from './templateStyles';
import classnames from 'classnames';
import { useMediaQuery } from '@mui/material';
import { PROMETHEAN_BREAKPOINT_NAV_CHANGE } from '../styles/breakpoints/breakpoints';
import { EmbersVerticalNav, EmbersMobileNavBar } from '../verticalNav';
export var PageTemplate = function PageTemplate(props) {
  var appTitle = props.appTitle,
    appIcon = props.appIcon,
    titleSlot = props.titleSlot,
    navProps = props.navProps,
    hidden = props.hidden,
    children = props.children,
    className = props.className;
  var mobileNavViewPort = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE, "px)"));
  return /*#__PURE__*/React.createElement(StyledTemplate, {
    className: classnames('EmbersTemplate-root', {
      'EmbersTemplate-withNav': navProps,
      'EmbersTemplate-mobile': mobileNavViewPort
    }, className)
  }, appTitle && !mobileNavViewPort && /*#__PURE__*/React.createElement(EmbersTitle, {
    type: "appTitle",
    text: appTitle,
    className: "EmbersTemplate-appTitle"
  }, titleSlot), /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-body"
  }, navProps && !navProps.hidden && /*#__PURE__*/React.createElement("div", {
    className: classnames('EmbersTemplate-nav', {
      'EmbersTemplate-nav-mobile': mobileNavViewPort
    })
  }, mobileNavViewPort ? /*#__PURE__*/React.createElement(EmbersMobileNavBar, _extends({}, navProps, {
    appIcon: appIcon
  })) : /*#__PURE__*/React.createElement(EmbersVerticalNav, navProps)), !hidden && children));
};